import { DateTimeHelper } from 'src/app/core/helper/datetime.helper';
import { DateTime } from 'luxon';
import { Entity } from 'src/app/core/data/schema/entity';

export class PastStripeAccount extends Entity {

    static className = 'PastStripeAccount';
    static idField = 'id';

    email: string;
    id: string;
    raffleName?: string;
    timesUsed: number;

    public constructor(init?: Partial<PastStripeAccount>) {
        super('PastStripeAccount', 'id');
        Object.assign(this, init);
    }

    public static async fetchAll() {
        return await PastStripeAccount.fetchArray(PastStripeAccount, 'raffles', 'paststripeaccounts');
    }
}

export class StripeAccountInfo extends Entity {
    static className = 'StripeAccountInfo';
    static idField = 'id';

    id: string;
    email: string;
    onboardingLink: string;
    status: StripeAccountStatus;
    payoutSchedule = '-'; // default to dash if not set
    payoutScheduleInterval: string;
    bankInfo: BankAccountInfo;

    public constructor(init?: Partial<StripeAccountInfo>) {
        super('StripeAccountInfo', 'id');

        Object.assign(this, init);
        if (this.bankInfo) {
            this.bankInfo = new BankAccountInfo(this.bankInfo);
        }
    }

    public static async load(raffleId: number, accountId: string) {
        const resp = await Entity.getObject(StripeAccountInfo, 'stripeconnect', `stripebankinfo/${raffleId}/${accountId}`);
        return new StripeAccountInfo(resp);
    }

    public static async createStripeAccount(raffleId: number, email: string): Promise<StripeAccountInfo> {
        const stripeAccountResp = await Entity.factory.post('Creating Stripe account', null, 'stripeconnect', `createstripeaccount/${raffleId}/${email}`);
        return new StripeAccountInfo(stripeAccountResp);
    }

    public static async getStripeOnboardingLink(raffleId: number, stripeId: string, linkType: string): Promise<StripeAccountInfo> {
        const onboardingLinkProfile = await Entity.getObject(StripeAccountInfo, 'stripeconnect', `stripeonboardinglink/${raffleId}/${stripeId}/${linkType}`);
        return onboardingLinkProfile;
    }
}

export class BankAccountInfo {
    bankName: string;
    currency: string;
    last4: string;

    public constructor(init?: Partial<BankAccountInfo>) {
        Object.assign(this, init);
    }
}

export class StripeBalance extends Entity {
    static className = 'StripeBalance';
    static idField = 'id';

    available: number;
    pending: number;
    currency: string;

    public constructor(init?: Partial<StripeBalance>) {
        super('StripeBalance', 'id');
        Object.assign(this, init);
    }


    public static async getStripeBalance(accountId: string, raffleId: number) {
        return new StripeBalance((await Entity.getObject(StripeBalance, 'stripeconnect', `stripedepositbalance/${raffleId}/${accountId}`)));
    }
}

export class StripePayoutRequest {
    accountId: string;
    bankAccountId: string;
    amount: number;
    currency: string;
}

export class StripePayout extends Entity {
    static className = 'StripePayout';
    static idField = 'id';

    id: string;
    status: string;
    amount: number;
    currency: string;
    createdAt: string;

    createdDisplay: string;

    public constructor(init?: Partial<StripePayout>) {
        super('StripePayout', 'id');
        Object.assign(this, init);

        // this date comes from stripe, so we need this ugly beast
        const d = DateTime.fromISO(new Date(this.createdAt).toISOString()).toISO();
        this.createdDisplay = DateTimeHelper.formatDate(d);
    }


    public static async fetchPayouts(raffleId: number, stripeAccountId: string) {
        return await Entity.fetchArray(StripePayout, 'stripeconnect', `${raffleId}/stripepayouthistory/${stripeAccountId}`);
    }
}

export enum StripeAccountStatus {
    NotConnected,
    Blocked,
    ActionRequired,
    InReview,
    Ready
}

